// import energySuppliers from "../static/data/energySuppliers";

const initialStateEnergy = {
    list: []
}

const initialStateGas = {
    list: []
}

export function supplierEnergyReducer (state = initialStateEnergy, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}

export function supplierGasReducer (state = initialStateGas, action) {
    switch (action.type) {
        default: {
            return state;
        }
    }
}